export const SvgPause = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20viewBox%3D"0%200%2028%2030"%3E%3Cpath%20d%3D"M0%200h10.24v30H0zM17.76%200H28v30H17.76z"%2F%3E%3C%2Fsvg%3E';
export default SvgPause;
